import React from 'react'
import { TableRow } from '@material-ui/core'
import { TableTitleCell } from '../../common/TableTitleCell'
import { TableValueCell } from '../../common/TableValueCell'
import { formatCellValue, ReportCellValue } from './report-utility'

export type ReportValuesRowProps = {
  title: string
  values: ReportCellValue[]
  highlightRow?: boolean
}

export function ReportValuesRow({
  title,
  values,
  highlightRow = false,
}: ReportValuesRowProps): React.ReactElement {
  return (
    <TableRow>
      <TableTitleCell highlight={highlightRow}>{title}</TableTitleCell>
      {values.map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableValueCell key={index} highlight={highlightRow}>
          {formatCellValue(value)}
        </TableValueCell>
      ))}
    </TableRow>
  )
}
